import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem ,Badge} from 'reactstrap';
import CitiesServices from "services/Admin/CitiesService"
import DeleteModal from "../DeleteModal"
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux"

const CardItem = ({ index, item, id, Service, name, status, setShouldGetData, }) => {
    const [deleteModal, setDeleteModal] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [itemStatus, setItemStatus] = useState(false);
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const service = new Service
    const toggle = () => setDropdownOpen(prevState => !prevState);

    useEffect(() => {
        setItemStatus(status)
         
    }, [status])
    const handleCloseModal = (action, response) => {
        setDeleteModal(false);
        if (action === "delete") {
            setShouldGetData(true)
        }
    };
 

    const changeStatus = (e) => {
        const value = e.target.checked
        service.toggleStatus(id).then((res) => {
            if (res && res.status === SuccessOk) {
                setItemStatus(value)
                toast.success("Status changed successfully");
                setTimeout(() => {
                    setShouldGetData(true)
                }, 1000);
            }
        });
    }

    return (
        <>
            <tr key={index}>
                <th className='font-size-14'>{item.id}</th>
                <th className='font-size-14' style={{textDecoration:"underLine",fontWeight:700}}>{item.user_name} - {item.name} </th>
                <th className='font-size-14'>{item.email}</th>
                <th className='font-size-14'>{item.phone}</th>
              
                <th className='font-size-14'>{item.areas?.map(area => {
                    return (
                        <>
                        <Badge className="bgBadge font-size-14 mt-0 m-1"  
                style={{ background: "#50a5f1",marginTop:"0px !important" }}>{area?.name}</Badge>
                         </>
                    )
                })}</th>
                <td className='font-size-14 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                                disabled={isExist("seller.edit") ? false:true}
                            />
                        </div>
                    </form>
                </td>
                {/* <td className='font-size-16'>{status ? "true" : "false"}</td> */}
                {isExist("seller.delete") ? <td className="removebtnhover"><Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle caret>
                        <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                        {/* <DropdownItem onClick={() => {
                            setAdd(false)
                            setEditObj(item)
                            toggleModal()
                        }}>Edit</DropdownItem> */}
                        <DropdownItem className="text-danger" onClick={() => {
                            setDeleteModal(!deleteModal);
                        }}>Remove Seller</DropdownItem>
                    </DropdownMenu>
                </Dropdown> </td>:null}
            </tr>
            {deleteModal && <DeleteModal
                open={deleteModal}
                titleMsg={name.en}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />}
        </>

    );
}

export default CardItem;